import getDeliveryServices from '~/api/getDeliveryServices';
import { prop, applySpec } from 'ramda';
import { SelectBase } from './SelectBase';
import { withSelect2 } from './withSelect2';
import { CancelToken } from 'axios';

const result = applySpec({
	id: prop('ID'),
	text: prop('UF_NAME'),
})

export const Select2DeliveryService = {
	name: 'Select2DeliveryService',
	extends: SelectBase,
	mixins: [
		withSelect2((vm) => ({
			ajax: {
				transport: (params, success, failure) => {
					vm.$options.controller?.cancel?.();

					const controller = CancelToken.source();
					vm.$options.controller = controller;

					getDeliveryServices(params.data.q)
						.then(success)
						.catch(failure);
				},
				processResults: (results) => ({
					results: results.map?.(result),
				}),
			},
			width: '100%',
		})),
	],
	watch: {
		value: {
			handler: function (serviceId, oldServiceId) {
				if (!serviceId) return

				getDeliveryServices().then((services) => {
					const service = services.find((service) => service.ID === serviceId)

					if (!service) return

					this.$options.select2.$element.append(new Option(service.UF_NAME, service.ID))
				})
			},
			immediate: true,
		},
	},

}
